import { IMessageDataVideo } from "@home-health-notify/domain";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import { useMediaUrlWithState } from "hhn-commons";
import React from "react";
import DisplayImage from "../../../common/DisplayImage";
import { DisplayMediaProps } from "../../../common/DisplayMediaProps";
import {
  VideoContentContainer,
  VideoContentOverlay,
  VideoContentWrapper,
  VideoIcon,
} from "../../messageType/contentType/VideoContent.style";

const VideoThumb = ({
  videoData,
  isShowOverlay = true,
  ...rest
}: {
  videoData: IMessageDataVideo;
  isShowOverlay?: boolean;
} & DisplayMediaProps) => {
  const thumbState = useMediaUrlWithState(videoData.thumbnail);
  const shouldShowOverlay = isShowOverlay && !thumbState.error;

  return (
    <VideoContentWrapper>
      <VideoContentContainer>
        {shouldShowOverlay && (
          <VideoContentOverlay>
            <VideoIcon color="inherit" />
            <PlayCircleFilledWhiteOutlinedIcon
              color="inherit"
              fontSize="large"
            />
          </VideoContentOverlay>
        )}
        <DisplayImage
          url={videoData.thumbnail}
          alt={videoData.text}
          {...rest}
        />
      </VideoContentContainer>
    </VideoContentWrapper>
  );
};

export default VideoThumb;
